// Resolved flags from the featureFlags query. Keys are defined only in the API registry
// (erp-api src/public/featureFlags/feature-flags.ts).
export type FeatureFlags = Record<string, boolean>;

// A key the API did not return counts as off.
export const isFeatureEnabled = (featureFlags: FeatureFlags | undefined, key: string) =>
  featureFlags?.[key] === true;

type MenuVisibilityInput = {
  menuItem: string;
  permissionData: Record<string, string[]> | undefined;
  featureFlags: FeatureFlags | undefined;
  // Set on a resource's options.featureFlag when the screen ships behind a flag.
  requiredFeatureFlag?: string;
};

// A menu item shows when the user may view it and, for a flagged screen, the tenant has the flag.
export const isMenuItemVisible = ({
  menuItem,
  permissionData,
  featureFlags,
  requiredFeatureFlag,
}: MenuVisibilityInput) => {
  const permission =
    permissionData?.[menuItem] ||
    (menuItem === 'pos-payment-channels' ? permissionData?.['reports'] : undefined);
  const hasViewPermission = permission?.includes('view') === true;
  if (!hasViewPermission) {
    return false;
  }
  return !requiredFeatureFlag || isFeatureEnabled(featureFlags, requiredFeatureFlag);
};
